/* eslint-disable */
<template>
  <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row class="titleMobile"
      :style="{gap: '1rem'}">
        <v-btn
          class="back"
          dark
          icon
          to="/configuration"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <h2> {{ $t('views.configuration.communication.title') }} </h2>
      </v-row>
      <div class="plantillaSuscrip">
        <v-row>
          <v-col cols="12">
            <div class="div-container">
              <template v-if="firstLoading">
                <div class="loadingProgress">
                  <v-progress-circular
                    class="primary--text"
                    :style="{marginLeft: '2rem'}"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </template>
              <template v-else>
                <p> {{ $t('views.configuration.communication.description') }} </p>

                <!--CANALES-->
                <div class="grid-container"
                  :style="{marginTop: '2rem', marginBottom: '2rem'}">
                  <v-row class="class-row">
                    <v-col class="icon-col">
                      <v-icon class="class-icon">icon-ayudadigital-appmovil</v-icon>
                    </v-col>
                    <v-col class="label-col">
                      <p>App ayudaDIGITAL</p>
                    </v-col>
                    <v-col class="switch-col">
                      <v-switch
                      :input-value="listaCanales[0].value"
                      :readonly="isReadonlyCanal(0)"
                      @click.prevent="handleCanalSwitch(0)"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row class="class-row">
                    <v-col class="icon-col">
                      <v-icon class="class-icon">icon-ayudadigital-whatsapp</v-icon>
                    </v-col>
                    <v-col class="label-col">
                      <p>WhatsApp</p>
                    </v-col>
                    <v-col class="switch-col">
                      <v-switch
                      :input-value="listaCanales[1].value"
                      :readonly="isReadonlyCanal(1)"
                      @click.prevent="handleCanalSwitch(1)"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row class="class-row">
                    <v-col class="icon-col">
                      <v-icon class="class-icon">mdi-email-outline </v-icon>
                    </v-col>
                    <v-col class="label-col">
                      <p>Correo electrónico</p>
                    </v-col>
                    <v-col  class="switch-col">
                      <v-switch
                      :input-value="listaCanales[2].value"
                      :readonly="isReadonlyCanal(2)"
                      @click.prevent="handleCanalSwitch(2)"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row class="class-row">
                    <v-col class="icon-col">
                      <v-icon class="class-icon">mdi-message-reply-outline</v-icon>
                    </v-col>
                    <v-col class="label-col">
                      <p>SMS</p>
                    </v-col>
                    <v-col  class="switch-col">
                      <v-switch
                      :input-value="listaCanales[3].value"
                      :readonly="isReadonlyCanal(3)"
                      @click.prevent="handleCanalSwitch(3)"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ConfigurationCommunication',
  data() {
    return {
      preferences: null,
      isLoadingPutPreferencias: true,
      listaCanales: [
        {
          id: 'firebase',
          label: 'App ayudaDIGITAL',
          value: false,
        },
        {
          id: 'whatsapp',
          label: 'WhatsApp',
          value: false,
        },
        {
          id: 'email',
          label: 'Correo electrónico',
          value: false,
        },
        {
          id: 'sms',
          label: 'SMS',
          value: false,
        },
        {
          id: 'silencio',
          label: 'Pausar',
          value: false,
        },
      ],
      typeBussiness: [],
      typeBussinessPreferences: [],
      firstLoading: false,
    };
  },
  props: {
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  methods: {
    isCitizen() {
      return this.user.hasIosUser();
    },
    isReadonlyCanal(index) {
      const primerosCanales = this.listaCanales.slice(0, 4);
      const activos = primerosCanales.filter((canal) => canal.value === true).length;

      return activos === 1 && primerosCanales[index].value === true;
    },
    handleCanalSwitch(index) {
      if (this.isReadonlyCanal(index)) {
        this.$store.dispatch('messages/createNotificationMessage', {
          type: 'warning',
          icon: 'mdi-alert',
          title: this.$t('views.configuration.communication.atLeastOneChannel'),
          timeout: this.$getConst('notifications.timeout'),
        });
        return;
      }

      const newValue = !this.listaCanales[index].value;
      const isTurningOff = newValue === false;
      const hasAnotherActive = this.listaCanales
        .slice(0, 4)
        .some((canal, canalIndex) => canalIndex !== index && canal.value === true);

      if (isTurningOff && !hasAnotherActive) {
        this.$store.dispatch('messages/createNotificationMessage', {
          type: 'warning',
          icon: 'mdi-alert',
          title: this.$t('views.configuration.communication.atLeastOneChannel'),
          timeout: this.$getConst('notifications.timeout'),
        });
        return;
      }

      this.$set(this.listaCanales, index, {
        ...this.listaCanales[index],
        value: newValue,
      });

      this.putPreferencias();
    },
    actualizaCanal(id, value) {
      const index = this.listaCanales.findIndex((canal) => canal.id === id);

      if (index !== -1) {
        this.listaCanales[index].value = value;
      }
    },
    async putPreferencias() {
      this.isLoadingPutPreferencias = true;

      const canaleFijos = this.typeBussiness;

      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$t('ticketActions.messages.creating'),
        },
      );
      const { id, userid } = this.$store.getters['session/user'];
      try {
        const canalesCompletos = [];

        this.typeBussinessPreferences.forEach((preferencia) => {
          let canalesActivos = [];
          if (canaleFijos.includes(preferencia.tipoNegocio.id)) {
            canalesActivos = this.listaCanales.filter((canal) => canal.value === true)
              .flatMap((canal) => this.$getConst(`canales.${canal.id}.modo`));
            const aux = {
              tipoNegocio: preferencia.tipoNegocio.id,
              canales: canalesActivos,
            };
            canalesCompletos.push(aux);
          } else {
            canalesActivos = preferencia.canales.map((canal) => canal.modo);
            const aux = {
              tipoNegocio: preferencia.tipoNegocio.id,
              canales: canalesActivos,
            };
            canalesCompletos.push(aux);
          }
        });

        const response = await this.$api.getClient('suscripciones').putCanalesPreferencias({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `gestnotif/suscriptores/${id}/preferencias`,
          },
          body: {
            organizacion: 'CA',
            preferencias: canalesCompletos,
          },
        });

        if (response) {
          this.isLoadingPutPreferencias = false;
        }

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('ticketActions.messages.success'),
          timeout: this.$getConst('notifications.timeout'),
        });
      } catch (error) {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('ticketActions.messages.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async getPreferencias() {
      const { id, userid } = this.$store.getters['session/user'];

      const preferencias = await this.$api.getClient('suscripciones').getCanalesPreferencias({
        apiCges: {
          delegado: userid,
          uuidSuscriptor: id,
          endpoint: `gestnotif/suscriptores/${id}/preferencias`,
        },
      });

      if (preferencias && preferencias.length > 0) {
        const tiposNegocio = this.typeBussiness;

        this.typeBussinessPreferences = preferencias;
        const canales = new Set();

        preferencias.forEach((item) => {
          if (tiposNegocio.includes(item.tipoNegocio.id)) {
            item.canales.forEach((canal) => {
              canales.add(canal.modo);
            });
          }
        });

        const listaCanales = [...canales];

        listaCanales.forEach((canal) => this.actualizaCanal(canal, true));

        if (canales && canales.length > 0) {
          // console.log('****getPreferencias', { canales, preferencias });
          canales.forEach((canal) => this.actualizaCanal(canal.modo, true));
        }
      }

      this.preferences = preferencias;
      this.isLoadingPutPreferencias = false;
    },
  },
  async created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });
      this.$router.push('/');
    } else {
      this.firstLoading = true;
      this.suscripcionesClient = this.$api.getClient('suscripciones');
      this.typeBussiness = await this.$api.getClient('suscripciones').getTiposNegocio(374);
      await this.getPreferencias();
      this.firstLoading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;

.div-container {
padding: 2rem;
}

  .v-menu__content{
      margin-top:2.5rem;
      box-shadow: none !important;
  }

  .class-row {
    height: 40px;
  }

  .icon-col{
    max-width: 50px !important;
  }

  .label-col {
    max-width: 200px !important;
  }

  .switch-col {
    max-width: 65px !important;
  }

  .ml-1_5 {
    margin-left: 1.5rem;
  }

  .plantillaSuscrip {
    background-color: white;
    /* padding: 1em 0em; */
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }

  .card {
    flex: 0 0 33.3333%;
  }

  .loadingProgress{
    height: 10rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
  }

  @media (max-width: 900px) {

    .card.v-card {
      flex: initial;
      flex-direction: column;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 600px) {
    .btn__suscripciones {
      margin-left: 0;
    }
    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .titleMobile{
      margin-left: 0rem !important;
    }
  }
  .mdi-email-outline:before {
    color: #27846d !important;
  }

  .icon-ayudadigital-appmovil:before {
    color: #27846d !important;
  }

  .mdi-message-reply-outline:before {
    color: #27846d !important;
  }

  .icon-ayudadigital-whatsapp:before {
    color: #27846d !important;
  }

</style>
